<template>
    <div class="notranslate">
        <div style="display: flex">
            <div style="padding-top: 3px;overflow: hidden;width: 100%;white-space:nowrap;">
                <div v-if="configsData.Prompted" class="prompted">
                    {{ configsData.Prompted }}
                </div>
            </div>
        </div>

        <div class="demo-text" v-if="active1 === 0">
            <div class="goods notranslate" ref="goodsWrapper">
                <div class="menu-wrapper" ref="menuWrapper" @scroll="handleScroll">
                    <mu-expansion-panel :expand="true" class="plan-pay-part">
                        <div slot="header" style=" height: 32px; line-height: 32px; min-height: 32px !important;">
                            {{ $t('buffet.payPark') }}</div>
                        <ul style="-webkit-overflow-scrolling: touch; -overflow-scrolling: touch;" class="notranslate">
                            <li v-for="(item, index) in buffetPayGoods" v-if="item.menuId == 0 && item.isShow"
                                :key="item.menuFoodTypeId" class="menu-item"
                                :class="{ 'current': item.menuFoodTypeId === currentMeneId }"
                                @click="selectMenu('good', index, item.menuFoodTypeId)">
                                <span class="text">{{ item.menuFoodTypeName }} <span class="badge-tip"
                                        v-if="item.typeTotal > 0">{{ item.typeTotal }}</span></span>
                                <img src="../assets/image/hot.png" v-if="item.isRecommend"
                                    style="width: 28px;position: absolute;left: 50px;margin-top:5px;" />
                            </li>
                        </ul>
                    </mu-expansion-panel>

                    <mu-expansion-panel :expand="true" class="plan-free-part">
                        <div slot="header" style=" height: 32px; line-height: 32px; min-height: 32px !important;">
                            {{ $t('buffet.freePark') }}</div>
                        <ul style="-webkit-overflow-scrolling: touch; -overflow-scrolling: touch;" class="notranslate">
                            <li v-if="historyShow" class="menu-item" :class="{ 'current': currentMeneId == 10000 }"
                                @click="selectMenu('history', 10000, 10000)">
                                <span class="text" style="font-weight: 600; ">{{ $t('buffet.history') }}</span>
                            </li>
                            <li v-for="(item, index) in buffetGoods" v-if="item.menuId == 0 && item.isShow" class="menu-item"
                                :key="item.menuFoodTypeId" :class="{ 'current': item.menuFoodTypeId === currentMeneId }"
                                @click="selectMenu('good', index, item.menuFoodTypeId)">
                                <span class="text">{{ item.menuFoodTypeName }} <span class="badge-tip"
                                        v-if="item.typeTotal > 0">{{ item.typeTotal }}</span></span>
                                <img src="../assets/image/hot.png" v-if="item.isRecommend"
                                    style="width: 28px;position: absolute;left: 50px;margin-top:5px;" />
                            </li>
                        </ul>
                    </mu-expansion-panel>
                </div>
                <div class="foods-wrapper notranslate" ref="foodsWrapper" @scroll="handleScroll"
                    style="background-color:#fff;">
                    <ul>
                        <li v-if="currSelectKey == 'history'">
                            <h1 class="title">{{ $t('buffet.history') }}</h1>
                            <div v-for="(item, index) in goods" :key="index" class="food-list food-list-hook">
                                <template v-for="(food, index1) in item.foodList">
                                    <div class="food-item" :key="index1" v-if="food.history == 1">
                                        <img width="140" height="80" :src="getImgUrl(food.foodImage, 200)"
                                            @click="selectFood(food)" />
                                        <div class="content">
                                            <h2 class="name">{{ food.foodName }}</h2>
                                            <div class="price" style="padding-top: 30px;">
                                                <span class="now">{{ food.payAmount }} {{ seller.unit }}</span><span
                                                    v-show="food.actDiscount != 1" class="old">{{ food.price }}
                                                    {{ seller.unit }}</span>
                                            </div>
                                            <div class="cart-wrapper">
                                                <cartcontrol :food="food" :package-type="0" :add-type="payClass" :person-num="personNum">
                                                </cartcontrol>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </li>
                        <template v-for="item in goods">
                            <li :key="item.menuFoodTypeId" class="food-list food-list-hook"
                                v-if="currentMeneId == item.menuFoodTypeId && currSelectKey == 'good'">
                                <h1 class="title">{{ item.menuFoodTypeName }}</h1>
                                <ul v-for="subType in subTypeList" :key="subType.menuFoodTypeId" class="food-item">
                                    <img width="140" height="80" :src="getImgUrl(subType.foodTypeImage, 200)" />
                                    <div class="content">
                                        <h2 class="name">{{ subType.menuFoodTypeName }}</h2>
                                        <div class="price" style="padding-top:30px;">
                                        </div>
                                        <div class="cart-wrapper">
                                            <mu-badge :content="getChoice()" badge-class="badge-class" color="#da5b3a"
                                                @click="openSelectSheet(subType.menuFoodTypeId)"></mu-badge>
                                        </div>
                                    </div>
                                </ul>
                                <ul v-for="food in item.foodList" :key="food.foodId" class="food-item"
                                    v-if="food.foodId > 0  && food.isShow">
                                    <img width="140" height="80" :src="getImgUrl(food.foodImage, 400)"
                                        @click="selectFood(food)" style="object-fit: contain;" />
                                    <div class="content">
                                        <h2 class="name">{{ food.foodName }}</h2>
                                        <div class="price" style="padding-top:30px;">
                                            <span class="now">{{ food.payAmount }} {{ seller.unit }}</span><span
                                                v-show="food.actDiscount != 1" class="old">{{ food.price }}
                                                {{ seller.unit }}</span>
                                        </div>
                                        <div class="cart-wrapper">
                                            <cartcontrol :food="food" :package-type="0" :add-type="payClass" :person-num="personNum">
                                            </cartcontrol>
                                        </div>
                                    </div>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
                <shopcart :select-foods="selectFoods" :add-type="payClass" :package-type="0" :is-seft="isSeft"
                    :is-seft-pay="isSeftPay">
                </shopcart>
                <food :food="selectedFood" :add-type="payClass" ref="food"></food>
            </div>
        </div>

        <div class="demo-text" v-if="active1 === 1">
            <seller></seller>
        </div>

        <div style="right:0;position:absolute;bottom:50px;" v-if="unPayTip != ''">
            <mu-chip class="demo-chip" key="1" color="error" @delete="removeTip(1)" delete>{{ unPayTip }}</mu-chip>
        </div>

        <mu-bottom-sheet :open.sync="selectOpen" style="overflow-y:auto;height:60%;">
            <mu-list @item-click="closeSelectSheet">
                <mu-sub-header>{{ $t('orderList.selectOne') }}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon" @click="closeSelectSheet"></mu-icon>
                <div class="foods-wrapper notranslate">
                    <div v-for="(item, index0) in goods" :key="index0">
                        <div v-if="menuId == item.menuFoodTypeId">
                            <ul v-for="food in item.foodList" :key="food.foodId" class="food-item"
                                v-if="food.foodId > 0">
                                <img width="140" height="80" :src="getImgUrl(food.foodImage, 400)"
                                    style="object-fit: contain;" @click="selectFood(food)" />
                                <div class="content">
                                    <h2 class="name">{{ food.foodName }}</h2>
                                    <div class="price" style="padding-top:30px;">
                                        <span class="now">{{ Number(food.price * food.actDiscount).toFixed(0) }}
                                            {{ seller.unit }}</span><span v-show="food.actDiscount != 1" class="old">{{
                                                food.price }}
                                            {{ seller.unit }}</span>
                                    </div>
                                    <div class="cart-wrapper">
                                        <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </mu-list>
        </mu-bottom-sheet>

        <mu-dialog title="Recommended" :open.sync="openRecommended" :overlay-close="true" id="dialogRecommended"
            :lock-scroll="true">
            <div class="foods-wrapper" style="overflow-y: auto;overflow-x:hidden;margin:0px;"
                :style="{ height: screenHeight + 'px' }">
                <div style="position:absolute;top:0px;left:0px;z-index:2021090820">
                    <img width="48" height="48" src="../assets/image/round_close.png" @click="closeRecommended">
                </div>
                <ul>
                    <li v-for="(item, index) in goods" :key="index" class="food-list food-list-hook">
                        <div v-for="food in item.foodList" :key="food.foodId" class="food-item"
                            v-if="food.recommended == 2" style="display:block;">
                            <div class="pop"><img width="46" height="22" src="../assets/image/pop.gif"></div>
                            <div style="display: block;"><img style="width:100%;object-fit: contain;" height="180"
                                    :src="getImgUrl(food.foodImage, 400)" /></div>
                            <div style="display: block;">
                                <h2
                                    style="margin: 5px 0 0 10px; height: 12px; line-height: 12px; font-size: 14px; color: #07111b;">
                                    {{ food.foodName }}</h2>
                                <div class="price" style="padding-top: 30px; margin-left: 10px;">
                                    <span
                                        style="font-size: 12px; color: #f01414; font-weight: 700; line-height: 24px; margin-right: 8px;">{{
                                            food.payAmount }}
                                        {{ seller.unit }}</span>
                                    <span v-show="food.actDiscount != 1"
                                        style=" font-size: 12px; text-decoration: line-through; color: #93999f; font-weight: 700; line-height: 24px;">{{
                                            food.price }}
                                        {{ seller.unit }}</span>
                                </div>
                                <div style=" position: absolute; right: 0; bottom: 12px;">
                                    <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div style="height: 46px; line-height: 46px; text-align: center; opacity: 0.4; background-color: rgb(0, 0, 0);color:#fff;"
                    v-if="openRecommended" @click="closeRecommended">
                    {{ $t('common.close') }}
                </div>

              
            </div>
        </mu-dialog>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange"
            :overlay-close="false" :esc-press-close="false">
            {{ $t('common.orderstatechange') }}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;">
                {{ $t('common.sure') }}</mu-button>
        </mu-dialog>

        <mu-dialog :title="$t('orderList.limitTimeTitle')" width="360" :open.sync="openOverTimeTip"
            :overlay-close="false" :esc-press-close="false">
            {{ $t('orderList.limitTimeTips') }}
            <mu-button slot="actions" flat color="primary" @click="closeOverTimeTip" style="color: #da5b3a;">
                {{ $t('common.sure') }}</mu-button>
        </mu-dialog>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
import shopcart from '../components/ShopCart'
import cartcontrol from '../components/CartControl'
import food from '../components/Food'
import seller from '../components/Seller'
import Vue from 'vue'

export default {
    inject: ['reload'],
    props: {
        isSeft: {
            type: Number,
            default: 0
        },
        isSeftPay: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            seller: {},
            currentIndex: 0,
            currentMeneId: 1,
            currSelectKey: '',
            active1: 0,
            goodsSourcs: [],
            goods: [],
            listHeight: [],
            scrollY: 0,
            selectedFood: {},
            curIndex: 0,
            panel: 0,
            selectOpen: false,
            recommendeds: [],
            openRecommended: false,
            screenHeight: document.documentElement.clientHeight - 60,
            isFrist: true,
            tableOrderInfo: {},
            cartList: [],
            configsData: {},
            order: {},
            unPayTip: '',
            historyShow: false,
            openOrderChange: false,
            timer: null,
            once: 0,
            menuId: 0,
            isAtTop: true,
            lastScrollTop: 0,
            personNum:1,
            openOverTimeTip:false,
        }
    },
    computed: {
        payClass() {
            if (this.order != null && this.personNum>0) {
                var everybodyCopies = 50;
                if (this.configsData.EverybodyCopies != null) {
                    everybodyCopies = parseInt(this.configsData.EverybodyCopies.toString());

                    var curItemEverybodyCopies = 0;
                    var curTotalSeveral = 0;

                    let groupList = this.groupBy(this.cartList, (cart) => {
                        return cart.foodId
                    });
                 
                    if (groupList != null && JSON.stringify(groupList) != '{}') {
                        this.goods.forEach((good) => {
                            good.foodList.forEach((food) => {
                                if (groupList[food.foodId] != undefined && groupList[food.foodId].length > 0) {
                                    curItemEverybodyCopies = (food.quantity == null ? 0 : food.quantity) + groupList[food.foodId].length;
                                }
                                else {
                                    curItemEverybodyCopies = (food.quantity == null ? 0 : food.quantity)
                                }
                                curTotalSeveral += parseInt(food.several * curItemEverybodyCopies);
                              
                                if (food.perMaxCopies > 0 && (curItemEverybodyCopies >= (food.perMaxCopies * this.personNum))) {
                                    this.unPayTip = this.$t('orderList.onePersonOrder', { num: food.perMaxCopies }) + ' ' + food.foodName;
                                    food.unPayTip = this.$t('orderList.onePersonOrder', { num: food.perMaxCopies });
                                    food.unAdd = true;
                                }
                                else if(food.everyTimeCopies>0&& food.quantity!=null && food.quantity>=food.everyTimeCopies){
                                    this.unPayTip = this.$t('orderList.maxEachTimeOrder', { num: food.everyTimeCopies }) + ' ' + food.foodName;
                                    food.unPayTip = this.$t('orderList.maxEachTimeOrder', { num: food.everyTimeCopies });
                                    food.unAdd = true;
                                }
                                else {
                                    this.unPayTip = '';
                                    food.unPayTip = '';
                                    food.unAdd = false;
                                }
                            })
                        })
                    }
                    if (curTotalSeveral > (everybodyCopies * this.personNum)) {
                        this.unPayTip = this.$t('orderList.timeLimit', { num: (everybodyCopies * this.personNum) });
                        return true;
                    }
                    else {
                        this.unPayTip = '';
                        return false;
                    }
                }
            }
            this.unPayTip = '';
            return false;
        },
        selectFoods() {
            let foods = [];
            this.goods.forEach((good) => {
                good.foodList.forEach((food) => {
                    if (food.quantity) {
                      foods.push(food);
                    }

                    // if(food.childIds!=null && food.childIds!='' && food.childIds!='0'){
                    //     parentFoods.push(food);
                    // }
                })
            })
            return foods
        },
        subTypeList() {
            return this.goods.filter((item) => item.menuId == this.currentMeneId)
        },
        buffetPayGoods() {
            let typeTotal = 0;
            var payGoods = [];
            this.goods.forEach((good) => {
                typeTotal = 0;
                good.foodList.forEach((food) => {
                    if (food.quantity) {
                        typeTotal += food.quantity;
                    }
                })
                good.typeTotal = typeTotal;
                if (good.isSeft == 0 && good.isSeftPay == 1) {
                    payGoods.push(good);
                }
            })
            //累加子分类的数量
            payGoods.forEach((item1) => {
                if (item1.menuId == 0) {
                    let typeTotal0 = 0;
                    payGoods.forEach((item2) => {
                        if (item1.menuFoodTypeId == item2.menuId) {
                            typeTotal0 += item2.typeTotal;
                        }
                    })
                    item1.typeTotal += typeTotal0;
                }
            })
            return payGoods
        },
        buffetGoods() {
            let typeTotal = 0;
            var freeGoods = [];
            this.goods.forEach((good) => {
                typeTotal = 0;
                good.foodList.forEach((food) => {
                    if (food.quantity) {
                        typeTotal += food.quantity;
                    }
                })
                good.typeTotal = typeTotal;
                if (good.isSeft == 1) {
                    freeGoods.push(good);
                }
            })
            //累加子分类的数量
            freeGoods.forEach((item1) => {
                if (item1.menuId == 0) {
                    let typeTotal0 = 0;
                    freeGoods.forEach((item2) => {
                        if (item1.menuFoodTypeId == item2.menuId) {
                            typeTotal0 += item2.typeTotal;
                        }
                    })
                    item1.typeTotal += typeTotal0;
                }
            })
            return freeGoods
        }
    },
    created() {
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    mounted() {
        this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo');
        this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        this.initData();
        if (this.timer == null) {
            this.timer = setInterval(() => {
                this.checkOrder()
            }, 10000);
        }
    },
    methods: {
        initData() {
            this.isFrist = false;
            this.lastScrollTop = 0;
            this.curIndex = this.isSeft;
            this.getConfigs();
            this.getMenuList();
        },
        jumpOrderChange() {
            this.openOrderChange = false;
            this.$router.push({
                path: '/result'
            })
        },
        groupBy(list, fn) {
            const groups = {};
            list.forEach(function (o) {
                const group = JSON.stringify(fn(o));
                groups[group] = groups[group] || [];
                groups[group].push(o);
            });
            return groups;
        },
        checkOrder() {
            this.openOrderChange = false;
            if (this.tableOrderInfo.tableName == undefined || this.tableOrderInfo.tableName == null || this.tableOrderInfo.tableName == '') {
                return;
            }
            let param = {
                tableName: this.tableOrderInfo.tableName,
                restaurantId: this.tableOrderInfo.restaurantId
            };
            this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                .then(response => {
                    if (response.code == 200) {
                        var data = response.data;
                        if (data == null || data == '') {
                            window.clearTimeout(this.timer);
                            this.openOrderChange = true;
                            this.openRecommended = false;
                        }
                        else{
                            if(this.configsData.BuffetTimeLimit!=undefined &&this.configsData.BuffetTimeLimit!=null)
                            if(this.isOverNMinutes(data.createTime,parseInt(this.configsData.BuffetTimeLimit))){
                                this.openOverTimeTip= true;
                            }
                        }
                    }
                });
        },
        isOverNMinutes(createTime, n) {
            const createTimestamp = new Date(createTime).getTime();
            const nowTimestamp = Date.now();
            const diff = nowTimestamp - createTimestamp;
            return diff > n * 60 * 1000;
        },
        removeTip(index) {
            this.unPayTip = "";
        },
        async getConfigs() {
            await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        response.data.forEach((item) => {
                            this.configsData[item.configKey] = item.configValue;
                            if(item.configKey=='OneTimeCharge'){
                               window.localStorage.setItem('oneTimeCharge', item.configValue);
                            }
                        })
                         if(this.configsData.Prompted1!=null && this.configsData.Prompted1!=''){
                                  this.$alert(this.configsData.Prompted1, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                            }
                    }
                });
        },
        goTop() {
            window.scrollTo(0, 0);
        },
        getChoice() {
            return this.$t('orderList.choice');
        },
        toggle(panel) {
            this.panel = panel === this.panel ? 0 : panel;
        },
        _initScroll() {
            this.menuScroll = new BScroll(this.$refs.menuWrapper, {
                click: true,
            })
            this.foodsScroll = new BScroll(this.$refs.foodsWrapper, {
                click: true,
                probeType: 1,

            })
            this.foodsScroll.on('scroll', (pos) => {
                this.scrollY = Math.abs(Math.round(pos.y));
            })
        },
        _calculateHeight() {
            let foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook')
            let height = 0
            this.listHeight.push(height)
            for (let i = 0; i < foodList.length; i++) {
                let item = foodList[i]
                height += item.clientHeight
                this.listHeight.push(height)
            }
        },
        closeSelectSheet() {
            this.selectOpen = false;
        },
        openSelectSheet(menuId) {
            this.menuId = menuId
            this.selectOpen = true;
        },
        tabChange(value) {
        },
        selectMenu(key, index, foodTypeId, title) {
            this.currSelectKey = key;
            this.currentIndex = index;
            this.currentMeneId = foodTypeId;
            //let foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');
            //let ref = foodList[0];
            this.$refs.foodsWrapper.scrollTop = 0;
            this.lastScrollTop =0;
        },
        selectFood(food) {
            this.selectedFood = food;
            this.$refs.food.show();
        },
        getMenuList() {
            let param = {
                restaurantId: this.tableOrderInfo.restaurantId,
                clientId: 1
            };
            this.$get('QRCodeOrder/GetBuffetFoodList', param)
                .then(response => {
                    if (response.code == 200) {
                        this.goods = response.data;
                        if (this.goods.length > 0) {
                            let defaultMenu = this.goods.filter((item) => item.menuId == 0);
                            if (defaultMenu.length > 0) {
                                this.currentMeneId = defaultMenu[0].menuFoodTypeId;
                                this.selectMenu('good', 1, this.currentMeneId);
                            }
                        }
                        this.getPersonCartList();
                        this.getOrderList();
                        //setTimeout(() => {
                        //    //this._initScroll()
                        //    //this._calculateHeight()
                        //}, 200);
                    } else {
                        this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                    }
                });
        },
        getOrderList() {
            let param = {
                tableName: this.tableOrderInfo.tableName,
                restaurantId: this.tableOrderInfo.restaurantId
            };
            this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                .then(response => {
                    if (response.code == 200) {
                        var data = response.data;
                        if (data == null || data == '') {
                            return;
                        }
                        this.order = data;
                        this.tableOrderInfo.orderTime = this.order.orderDay.replace('/Date(', '').replace(')/', '');
                        this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: this.order.orderId })
                            .then(result => {
                                if (result.code == 200) {
                                    this.cartList = result.data;
                                    var cartPackageIds=[];
                                    if(this.cartList.length>0){
                                        this.personNum= this.cartList.filter(item => item.packageType > 1).reduce((sum, item) => sum + (item.quantity || 0), 0);
                                            cartPackageIds = this.cartList
                                                                    .filter(item => item.packageType > 1)
                                                                    .map(item => item.foodId); 
                                    }
                                    const seenFoodIds = new Set();
                                    this.goods.forEach((good) => {
                                        good.isShow=true;
                                        good.foodList.forEach((food) => {
                                            food.isShow=true;
                                            this.cartList.forEach((cart) => {
                                                     //校验是否有归属
                                                    if(food.packageIds!=null && food.packageIds!=''){
                                                        const packageIdArr = food.packageIds.split(',').map(Number);
                                                        const hasCommonId = cartPackageIds.some(id => packageIdArr.includes(id));
                                                        if(hasCommonId){
                                                             food.isShow=true;
                                                         }
                                                         else{
                                                             food.isShow=false;
                                                         }
                                                    }
                                                if (food.foodId == cart.foodId&&!seenFoodIds.has(food.foodId)) {
                                                    seenFoodIds.add(food.foodId);
                                                    food.history = 1;
                                                    if(food.chargedOnce==1){
                                                        food.payAmount=0;
                                                    }
                                                    this.historyShow = true;
                                                    //校验是否不能新增了
                                                    if (food.perMaxCopies > 0) {
                                                        if (cart.quantity >= (food.perMaxCopies * this.personNum)) {
                                                             Vue.set(food, 'unAdd', true);
                                                             Vue.set(food, 'unPayTip', this.$t('orderList.oneOnlyOrder', { num: food.PerMaxCopies }));
                                                            //food.unAdd = true;
                                                            //food.unPayTip = this.$t('orderList.oneOnlyOrder', { num: food.PerMaxCopies });
                                                        }
                                                    }
                                                    if(food.everyTimeCopies>0){
                                                        if(food.quantity!=null && food.quantity>=food.everyTimeCopies){
                                                            Vue.set(food, 'unAdd', true);
                                                            Vue.set(food, 'unPayTip', this.$t('orderList.maxEachTimeOrder', { num: food.everyTimeCopies }));
                                                        }
                                                    }
                                                }
                                            });
                                        });
                                            var typeShowList= good.foodList.filter(it => it.isShow);
                                            if(typeShowList.length==0){
                                                console.log(good);
                                                good.isShow=false;
                                            }
                                    });
                                    this.once += 1
                                }
                            });
                    }
                });
        },
        getPersonCartList() {
            this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo');
            let param = {
                RestaurantId: this.tableOrderInfo.restaurantId,
                TableName: this.tableOrderInfo.tableName,
                CreateUser: this.tableOrderInfo.name
            };
            this.$get('QRCodeOrder/GetPersonCart', param)
                .then(response => {
                    if (response.code == 200 && response.data.length > 0) {
                        var personCartList = response.data;
                        this.goods.forEach((good) => {
                            good.foodList.forEach((food) => {
                                personCartList.forEach((item) => {
                                    if (item.relatedId == food.relatedId) {
                                        if (!food.quantity) {
                                            Vue.set(food, 'quantity', item.quantity);
                                            if (item.decideName != null && item.decideName != '') {
                                                Vue.set(food, 'decideName', item.decideName);
                                                Vue.set(food, 'payAmount', item.price);
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    }
                });
        },
        getImgUrl(image, w = 0) {
            if (image == undefined || image == 'undefined' || image == null || image == '') {
                return '../static/img/default.png';
            }
            if (w == 0) {
                return this.global.baseUrl + "uploads/" + image
            }
            return this.global.baseUrl + "api/images/" + w + "/" + image
        },
        getPath() {
            if (this.$route.path == '/buffet' && !this.isFrist) {
                this.getPersonCartList();
                this.getOrderList();
            }
        },
        handleScroll() {
            // const wrapper = this.$refs.foodsWrapper;
            // const menuWrapper = this.$refs.menuWrapper
            // const goodsWrapper = this.$refs.goodsWrapper;
            // const scrollTop = wrapper.scrollTop;
            // const delta =  scrollTop - this.lastScrollTop;
            // if (scrollTop === 0) {
            //     this.isAtTop = true;
            // } else {
            //     this.isAtTop = false;
            // }
            // if (wrapper.scrollTop > 0) {
            //     goodsWrapper.style.top = '20px';
            // }
            // if (menuWrapper.scrollTop > 0) {
            //     goodsWrapper.style.top = '20px';
            // }
            // if (this.isAtTop && delta < 0) {
            //     goodsWrapper.style.top = '60px';
            // }
            // this.lastScrollTop = scrollTop;
        },
        closeRecommended() {
            this.openRecommended = false;
        },
        closeOverTimeTip(){
            this.openOverTimeTip=false;
        },
    },
    watch: {
        '$route': 'getPath'
    },
    components: {
        shopcart,
        cartcontrol,
        food,
        seller
    }
}
</script>
<style scoped>
/deep/ .mu-expansion-toggle-btn.mu-button {
    margin-right: 0px !important;
}

#dialogRecommended>>>.mu-dialog {
    min-width: 90% !important;
}

#dialogRecommended>>>.mu-dialog-body {
    padding: 0 !important;
}

#dialogRecommended>>>.mu-dialog-title {
    background-color: #93999f;
    padding: 0;
    color: #fff;
    display: none;
}
</style>
<style lang="stylus" rel="stylesheet/stylus">
    .goods {
        position: fixed;
        top:48px;
        bottom: 44px;
        width: 100%;
        max-width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        overflow: hidden;
        background-color: #f5f5f5;
        margin-top: 30px;
    }

        .goods .menu-wrapper {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 90px;
            flex: 0 0 90px;
            background: #f5f5f5;
            overflow-y: auto;
        }

            .goods .menu-wrapper::-webkit-scrollbar {
                width: 0px;
                background: #f5f5f5;
            }

            .goods .menu-wrapper .menu-item {
                width: 100%;
                height: 48px;
                line-height: 48px;
                display: table;
                padding: 0 8px;
                margin: 0 auto;
                background: #f5f5f5;
                position: relative;
            }

                .goods .menu-wrapper .menu-item.current {
                    position: relative;
                    background: #fff;
                    font-weight: 700;
                    margin-top: -1px;
                    z-index: 100;
                }

                    .goods .menu-wrapper .menu-item.current .text:after {
                        border-top: 0;
                    }

                .goods .menu-wrapper .menu-item:last-child .text:after {
                    border-top: none;
                }



                .goods .menu-wrapper .menu-item .text {
                    display: inline-block;
                    vertical-align: middle;
                    position: relative;
                    width: 100%;
                    font-size: 12px;
                    float: left;
                    height: 56px;
                    font-weight: 600;
                    line-height: 56px;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    white-space: normal !important;
                }

                    .goods .menu-wrapper .menu-item .text:after {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        border-top: 1px solid rgba(7,17,27,0.1);
                        content: '';
                    }

                    .goods .menu-wrapper .menu-item .text .icon {
                        vertical-align: top;
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        margin-right: 4px;
                        background-size: 12px 12px;
                        background-repeat: no-repeat;
                    }

        .goods .foods-wrapper {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
        }

            .goods .foods-wrapper h1 {
                margin: 0px;
            }

            .goods .foods-wrapper .title {
                padding-left: 14px;
                border-left: 2px solid #d9dde1;
                font-size: 12px;
                height: 26px;
                line-height: 26px;
                color: #93999f;
                background-color: #f3f5f7;
            }

            .goods .foods-wrapper .food-item {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                margin: 5px;
                padding-bottom: 10px;
                margin-right: 10px;
                position: relative;
            }

                .goods .foods-wrapper .food-item:after {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    border-top: 1px solid rgba(7,17,27,0.1);
                    content: '';
                }

                .goods .foods-wrapper .food-item:last-child:after {
                    border-top: 0;
                }

                .goods .foods-wrapper .food-item .icon {
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 57px;
                    flex: 0 0 57px;
                    margin-right: 10px;
                }

                .goods .foods-wrapper .food-item .content {
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    margin-left: 5px;
                }

                    .goods .foods-wrapper .food-item .content .name {
                        margin: 2px 0 8px 0;
                        height: 12px;
                        line-height: 12px;
                        font-size: 14px;
                        color: #07111b;
                    }

                    .goods .foods-wrapper .food-item .content .description,
                    .goods .foods-wrapper .food-item .content .extra {
                        font-size: 10px;
                        line-height: 10px;
                        color: #93999f;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                        height: 10px;
                        line-height: 10px;
                    }

                        .goods .foods-wrapper .food-item .content .extra .count {
                            margin-right: 12px;
                            line-height: 10px;
                        }

                        .goods .foods-wrapper .food-item .content .extra .rating {
                            line-height: 10px;
                        }

                    .goods .foods-wrapper .food-item .content .price .now {
                        font-size: 12px;
                        color: #f01414;
                        font-weight: 700;
                        line-height: 24px;
                        margin-right: 8px;
                    }

                    .goods .foods-wrapper .food-item .content .price .old {
                        font-size: 12px;
                        text-decoration: line-through;
                        color: #93999f;
                        font-weight: 700;
                        line-height: 24px;
                    }

                    .goods .foods-wrapper .food-item .content .cart-wrapper {
                        position: absolute;
                        right: 0;
                        bottom: 12px;
                    }


    .mu-icon-button {
        line-height: 1;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 0px;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: none;
        color: inherit;
        background-color: transparent;
    }

    .badge-tip {
        font-size: 10px;
        color: #f01414;
        font-weight: 600;
        position: absolute;
        right: 0px;
        top: -12px;
    }

    .mu-expansion-panel__expand {
        margin: 0px;
    }

        .mu-expansion-panel__expand .mu-expansion-panel-header {
            min-height: 32px;
        }

    .mu-expansion-panel-header {
        padding: 0px;
        padding-left: 5px;
        width: 100%;
        font-size: 12px;
        word-break: break-all;
        word-wrap: break-word;
        background-color: #93999f;
        color: #fff;
        min-height: 32px;
    }

    .mu-expansion-panel {
        color: rgba(0,0,0,.87);
    }

    .mu-expansion-panel-content {
        padding: 0px;
    }

    .mu-expansion-toggle-btn svg {
        width: 14px;
        height: 14px;
        fill: currentColor;
        -ms-flex-negative: 0;
        flex-shrink: 0;
    }

    .mu-icon-button {
        line-height: 1;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 0px;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: none;
        color: inherit;
        background-color: transparent;
    }

    .plan-pay-part {
        color: #da5b3a;
    }

    .plan-free-part {
        color: #4caf50;
    }
        .pop {
            position: absolute;
            top: 15px;
            right: 0px;
            transform: rotate(38deg);
            -o-transform: rotate(38deg);
            -webkit-transform: rotate(38deg);
            -moz-transform: rotate(38deg);
        }

        .badge-class {
            font-size: 16px;
        }

        .scroll-container {
            overflow: hidden;
            white-space: nowrap;
          }
           
          .prompted {
            display: inline-block;
            transform: translateX(100%); /* 初始位置强制右侧外部 */
            animation: scroll 30s linear infinite;
            will-change: transform;
            color:#DA5B3A;
          }
           
          @keyframes scroll {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
</style>



// WEBPACK FOOTER //
// src/components/BuffetGoods.vue